const version = "Semmelsockerkaka 2026-03-18";

export default version;
